<div class="container my-5">

  <div class="container lh-sm  mx-0 text-center">
    <span class="fs-2  fw-medium ">Consulta médica</span>
    <br>
    <span class="fs-2 fw-bold">a un clic de distancia</span>

  </div>


  <!-- Three columns of text below the carousel -->
  <div class="row d-flex mx-auto   w-75">
    <div class="col-lg-4 my-4">
      <div class="container d-flex align-items-center px-1 gap-2">
        <img src="/assets/img/onlink/medicinageneral.svg" alt="medicinageneral" width="75" height="75">
        <span class="fs-4 fw-semibold">Medicina General</span>
      </div>
    </div><!-- /.col-lg-4 my-4 -->
    <div class="col-lg-4 my-4">
      <div class="container d-flex align-items-center gap-2">
        <img src="/assets/img/onlink/ginecologia.svg" alt="ginecologia" width="75" height="75">
        <span class="fs-4 fw-semibold">Ginecología</span>
      </div>
    </div><!-- /.col-lg-4 my-4 -->
    <div class="col-lg-4 my-4">
      <div class="container d-flex align-items-center gap-2">
        <img src="/assets/img/onlink/pediatria.svg" alt="pediatria" width="75" height="75">
        <span class="fs-4 fw-semibold">Pediatría</span>

      </div>
    </div><!-- /.col-lg-4 my-4 -->
  </div><!-- /.row -->



</div>
